module.exports = __webpack_public_path__ + "99a39d375138d654ad91bb58668dbe43.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/bat-s.png
// module id = 1984
// module chunks = 0